// Who's coming (B9). A trip names the children on it (`meta.travellers`, set on Organiser ›
// Trips); absent, every child is. A child who isn't coming sees it as a read-only "family trip":
// they can follow the plan, but don't check in, add plans or earn from it. Their own world (WI-13)
// doesn't change. Grown-ups always see the trip as it is.
import type { TripMeta } from '../../../shared/pack/schema'

type Who = { id: string; kind: string }

export function onTrip(meta: Pick<TripMeta, 'travellers'>, person: Who): boolean {
  if (person.kind !== 'child') return true
  return !meta.travellers || meta.travellers.includes(person.id)
}

/**
 * The `travellers` value for a set of ticked children: null when every child is ticked (the
 * default, so a child added later is on the trip too), else the ticked ids in family order.
 */
export function travellersFor(children: readonly Who[], ticked: ReadonlySet<string>): string[] | null {
  const ids = children.filter((c) => c.kind === 'child').map((c) => c.id)
  return ids.every((id) => ticked.has(id)) ? null : ids.filter((id) => ticked.has(id))
}
